// extracted by mini-css-extract-plugin
module.exports = {"Call":"Call_Call__MmYLL","textContainer":"Call_textContainer__Bw34S","iconList":"Call_iconList__3uL6Q"};